<template>
	<q-field :error="gradeInvalid" error-label="Please enter a grade">
		<!-- https://github.com/quasarframework/quasar/issues/1906#issuecomment-386029700 -->
		<q-input
			autocomplete="off"
			maxlength="5"
			:dark="dark"
			color="secondary"
			placeholder="(Optional)"
			v-model="grade"
			@blur="emitChange"
			@keyup.enter="emitChange"
			float-label="Grade" />
	</q-field>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { mapMutations } from 'vuex';
import { CourseEntry } from '@/models';
import CourseEntryValidator from '@/models/validation/CourseEntryValidator';
import config from '@/models/services/config';

@Component({
	methods: mapMutations('wmct', {
		updateCourseGrade: 'UPDATE_COURSE_GRADE',
	}),
})
export default class GradeInput extends Vue {
	@Prop() public value!: CourseEntry;

	private get dark() {
		return config.Dark;
	}

	private updateCourseGrade!: ({ course, grade }: { course: CourseEntry, grade: string | null }) => void;

	private get validating() {
		return this.value.isValidating;
	}

	public get grade() {
		return this.value.grade;
	}
	public set grade(grade: string | null) {
		this.updateCourseGrade({ course: this.value, grade });
	}

	public get gradeInvalid() {
		return false;
	}

	@Emit('change')
	private emitChange(newValue: string) { /* */ }
}
</script>
